import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import Translations from 'src/core/utils/Translations';

const initialState: {
	isEditing: boolean;
	EditingBtnText: string;
	sortable: boolean;
	scrollEnabled: boolean;
	disabled: boolean;
	opacity: number;
	selectedCells: unknown[];
} = {
	isEditing: false,
	EditingBtnText: Translations.buttonEdit,
	sortable: false,
	scrollEnabled: false,
	disabled: false,
	opacity: 0,
	selectedCells: [],
};

export const useEditModeStore = create(
	combine(initialState, (set, get) => ({
		reset: () => set({ ...initialState }),

		toggle: () => {
			const { isEditing, EditingBtnText, sortable, disabled, opacity } = get();
			set({
				EditingBtnText: EditingBtnText === Translations.buttonEdit ? Translations.buttonDone : Translations.buttonEdit,
				isEditing: !isEditing,
				sortable: !sortable,
				disabled: !disabled,
				opacity: opacity === 0 ? 1 : 0,
			});
		},
	})),
);
